/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Okular_PlatformsInputs */

const en_pc_alt_t_okular_platforms = /** @type {(inputs: Pc_Alt_T_Okular_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux, Windows`)
};

const zh_pc_alt_t_okular_platforms = /** @type {(inputs: Pc_Alt_T_Okular_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux、Windows`)
};

/**
* | output |
* | --- |
* | "Linux, Windows" |
*
* @param {Pc_Alt_T_Okular_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_okular_platforms = /** @type {((inputs?: Pc_Alt_T_Okular_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Okular_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_okular_platforms(inputs)
	return zh_pc_alt_t_okular_platforms(inputs)
});
export { pc_alt_t_okular_platforms as "pc.alt.t.okular.platforms" }